/* eslint-disable import/first */
require('dotenv').config()

import 'typeface-roboto'
import 'react-toastify/dist/ReactToastify.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { Router } from 'react-router'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/react-hooks'
import * as serviceWorker from './serviceWorker'

import './index.css'
import { history, store } from './store'
import theme from './theme.mui'
import Routes from './routes'
import apolloClient from './apolloClient'

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <Router history={history}>
          <Routes />
        </Router>
      </Provider>
    </ApolloProvider>
  </MuiThemeProvider>,
  document.getElementById('root'),
)

serviceWorker.unregister()
